<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item prop="roleName" label="角色名称">
          <el-input
            v-model="listForm.roleName"
            placeholder="请输入角色名称"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="handleSearch"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="resetForm"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          class="add-button"
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增角色</el-button
        >
      </el-col>
    </el-row>
    <el-table :data="rolesList" style="width: 100%" border v-loading="loading">
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="roleName"
        label="角色名称"
        align="center"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="sortId"
        label="排序号"
        align="center"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
            @change="statusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="updateUserName" label="最后操作人" align="center">
      </el-table-column>
      <el-table-column prop="updateTime" label="最后操作时间" align="center" width="180">
      </el-table-column>
      <el-table-column
        prop="age"
        label="操作"
        align="center"
        width="200"
        class="handle-btn"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.isMain !== 1"
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.isMain !== 1"
            type="warning"
            size="mini"
            icon="el-icon-setting"
            @click="configPower(scope.row)"
            >配置权限</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="pageSize"
      :total="total"
      :current-page="pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input
            v-model="form.roleName"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="sortId">
          <el-input v-model="form.sortId" placeholder="请输入排序号" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="form.remark"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="角色配置"
      :visible.sync="showConfig"
      :close-on-click-modal="false"
      @close="handleConfigClose"
    >
      <div>
        <div class="roleInfo">
          {{ roleName }}
        </div>
        <div class="head-container">
          <el-tree
            :data="menuTree"
            :props="defaultProps"
            show-checkbox
            :expand-on-click-node="false"
            ref="navTree"
            node-key="id"
            :default-expand-all="isShowNode"
            :default-checked-keys="navIdList"
            @check="checkboxChange"
          >
            <div class="custom-tree-node tree-list" slot-scope="{ data }">
              <span>{{ data.title }}</span>
              <!-- <el-checkbox-group
                v-model="data.btns"
                v-if="data.children && data.children.length == 0"
                class="btn-checkbox"
              >
                <el-checkbox
                  @change="(checked) => handleMenuBtns(checked, data, item)"
                  :checked="item.checked"
                  v-for="item in data.menuBtns"
                  :label="item.id"
                  :key="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group> -->
            </div>
          </el-tree>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="showConfig = false">取 消</el-button>
        <el-button type="primary" @click="savePowerConfig()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSystemRolesListPage,
  saveSystemRoles,
  updateSystemRoles,
  updateRolesStatus,
  getSystemAllNavList,
  getSystemNavigationId,
  saveRolesNav,
} from "@/common/api.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      pageSize: 10,
      pagenum: 1,
      total: 0,
      dialogVisible: false,
      loading: false,
      showConfig: false,
      //菜单列表
      menuTree: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      // 拥有菜单id列表
      navIdList: [],
      roleId: null,
      roleName: "",
      isShowNode: true,
      searchShow: true,
      dialogConfig: false,
      dialogDetails: false,
      rolesList: [],
      listForm: {
        roleName: "",
      },

      form: {
        roleName: "",
        roleType: "systemRole",
        sortId: null,
        remark: "",
      },
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        roleName: [
          { required: true, validator: this.testName, trigger: "blur" },
        ],
      },
      btns: [],
      menuBtns: [],
      menuList: [],
      systemPermissionNaviList: [],
      systemRoleNavigationMenuBtnList: [],
      selectNav: [],
      selectMenu: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    //角色列表
    getSystemRolesList() {
      var params = {
        pageSize: this.pageSize,
        pagenum: this.pagenum,
        data: {
          roleType: "systemRole",
          roleName: this.listForm.roleName,
        },
      };
      this.loading = true;
      getSystemRolesListPage(params).then((res) => {
        console.log("res :>> ", res);
        this.loading = false;
        if (res.errorCode == 200) {
          this.rolesList = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 保存新增/编辑
    saveAddOrEdit() {
      // console.log(this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.form.roleId) {
            updateSystemRoles(this.form).then((res) => {
              this.loading = false;
              if (res.errorCode == "200") {
                this.getSystemRolesList();
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            saveSystemRoles(this.form).then((res) => {
              this.loading = false;
              if (res.errorCode == 200) {
                this.getSystemRolesList();
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },

    //选页
    handleCurrentChange(cpage) {
      this.pagenum = cpage;
      this.getSystemRolesList();
    },
    handleSizeChange(psize) {
      this.pageSize = psize;
      this.getSystemRolesList();
    },

    // 新增机构
    handleAdd() {
      this.reset();
      this.dialogVisible = true;
      this.title = "新增角色";
    },
    // 编辑机构
    edit(row) {
      this.reset();
      this.dialogVisible = true;
      this.title = "编辑角色";
      this.form = {
        roleName: row.roleName,
        roleType: "systemRole",
        sortId: row.sortId,
        remark: row.remark,
        roleId: row.roleId,
      };
    },
    // 配置权限
    configPower(row) {
      this.showConfig = true;
      this.roleId = row.roleId;
      this.roleName = row.roleName;
      this.getSystemNavigationId(row.roleId);
    },
    // 监听配置权限dialog
    handleConfigClose() {
      this.$nextTick(() => {
        this.$refs.navTree.setCheckedKeys([]);
      });
    },
    // 获取所有菜单列表
    getSystemAllNavList(type) {
      var data = {
        navType: "system",
      };
      getSystemAllNavList(data).then((res) => {
        if (res.errorCode == 200) {
          this.menuTree.push(res.data);
          // console.log(this.menuTree);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 该角色拥有的菜单id
    getSystemNavigationId(id) {
      var data = {
        roleId: id,
      };
      var list = [];
      this.selectNav = [];
      this.selectMenu = [];
      getSystemNavigationId(data).then((res) => {
        if (res.errorCode == 200) {
          var dataList = res.data;
          if (dataList && dataList.length > 0) {
            dataList.forEach((item) => {
              list.push(item.id);
              this.selectNav.push({
                roleId: this.roleId,
                naviId: item.id,
                naviName: item.name,
              });
              if (item.btns && item.btns.length > 0) {
                item.btns.forEach((arr) => {
                  this.selectMenu.push({
                    roleId: this.roleId,
                    navigationId: item.id,
                    menuBtnId: arr,
                    sort: "1",
                  });
                });
              }
            });

            console.log(this.selectMenu);
            this.navIdList = list;
            getMenuBtns(this.menuTree);
            function getMenuBtns(array) {
              array.forEach((item) => {
                item.btns = [];
                for (var k in dataList) {
                  if (dataList[k].id == item.id) {
                    item.btns = dataList[k].btns;
                  }
                }
                if (item.children && item.children.length > 0) {
                  getMenuBtns(item.children);
                }
              });
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 节点被点击发生变化
    checkboxChange(data, json) {
      this.selectNav = [];
      var ridsb = this.$refs.navTree
        .getCheckedNodes()
        .concat(this.$refs.navTree.getHalfCheckedNodes());
      if (ridsb.length > 0) {
        ridsb.forEach((item) => {
          var obj = {
            roleId: this.roleId,
            naviId: "",
            naviName: "",
          };
          obj.naviId = item.id;
          obj.naviName = item.title;
          this.selectNav.push(obj);
        });
      }
      var nodeArr = json.checkedNodes;
      var isHaveNode = false;
      nodeArr.forEach((item) => {
        if (item.id == data.id) {
          isHaveNode = true;
        }
      });
      if (!isHaveNode) {
        data.btns = [];
        if (data.children && data.children.length > 0) {
          getNav(data.children);
        }
        function getNav(array) {
          array.forEach((item) => {
            item.btns = [];
            if (item.children && item.children.length > 0) {
              getNav(item.children);
            }
          });
        }
      }
      // console.log(json.checkedNodes);
    },
    // 监听选择按钮
    handleMenuBtns(checked, data, item) {
      var btnId = item.id;
      var navId = data.id;
      if (checked) {
        var ishave = false;
        if (this.selectNav.length > 0) {
          for (var i = 0; i < this.selectNav.length; i++) {
            if (this.selectNav[i].naviId == navId) {
              ishave = true;
              break;
            }
          }
          if (!ishave) {
            this.$message.error("请先选择菜单");
            data.btns = [];
          }
        } else {
          this.$message.error("请先选择菜单");
        }
      }
    },
    // 保存权限配置
    savePowerConfig() {
      console.log(this.menuTree);
      var list = [],
        data = {};
      var ridsb = this.$refs.navTree
        .getCheckedNodes()
        .concat(this.$refs.navTree.getHalfCheckedNodes()); // 获取当前的选中的数据{对象}
      var mentList = [];
      var roleId = this.roleId;
      getMenuList(this.menuTree);
      function getMenuList(array) {
        array.forEach((item) => {
          if (item.btns && item.btns.length > 0) {
            item.btns.forEach((list) => {
              mentList.push({
                roleId: roleId,
                navigationId: item.id,
                menuBtnId: list,
                sort: "",
              });
            });
          }
          if (item.children && item.children.length > 0) {
            getMenuList(item.children);
          }
        });
      }
      if (ridsb.length > 0) {
        ridsb.forEach((item) => {
          var obj = {
            roleId: this.roleId,
            naviId: "",
            naviName: "",
          };
          obj.naviId = item.id;
          obj.naviName = item.title;
          list.push(obj);
        });

        data.roleId = this.roleId;
        data.systemPermissionNaviList = list;
        data.systemRoleNavigationMenuBtnList = mentList;
        saveRolesNav(data).then((res) => {
          if (res.errorCode == 200 && res.msg == "数据正常") {
            this.showConfig = false;
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("请选择需要配置的权限");
      }
    },
    //修改角色状态
    statusChange(row) {
      var department = row.roleName;
      let text = "";
      if (row.status == 1) {
        text = "有效";
      } else if (row.status == 0) {
        text = "失效";
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h(
            "h3",
            null,
            '是否将 "' + department + '" 的状态变为 "' + text + '" ?',
            "警告"
          ),
        ]),
        showCancelButton: true,
        closeOnClickModal:false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              roleId: row.roleId,
              status: row.status,
            };
            updateRolesStatus(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 表单重置
    reset() {
      this.form = {
        roleName: "",
        roleType: "systemRole",
        sortId: null,
        remark: "",
      };
    },
    //弹框关闭 重置form
    handleClose() {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
    // 查询
    handleSearch() {
      this.pagenum = 1;
      this.getSystemRolesList();
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs["listForm"].resetFields();
        this.getSystemRolesList();
      });
    },
    close() {
      this.dialogVisible = false;
    },
    isExpand() {
      this.isShowNode = !this.isShowNode;
    },
    //查看配置
    checkConfig() {
      this.dialogConfig = true;
    },
    testName(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str =
          /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入角色名称"));
      }
    },
  },
  created() {},
  mounted() {
    this.getSystemRolesList();
    this.getSystemAllNavList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .add-button {
    margin: 20px 0 10px 10px;
  }
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
  }
  .btn-checkbox {
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #13ce66;
      border-color: #13ce66;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      color: #13ce66;
    }
  }
  /deep/.el-input__inner,
  /deep/.el-form-item__content {
    height: 34px;
    line-height: 34px;
  }
  /deep/.el-input__icon,
  /deep/.el-form-item__label {
    line-height: 34px;
  }
  .tree-list {
    font-size: 14px;
    color: #333333;
    font-weight: 600;
    display: table;
    .tree-status {
      font-size: 12px;
      background-color: #f0f0f0;
      padding: 2px 3px;
      color: red;
    }
  }
  .roleInfo {
    text-align: center;
    padding-bottom: 20px;
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
  .el-checkbox-group {
    display: inline-block;
    margin-left: 20px;
    white-space: normal;
    vertical-align: middle;
    width: 78%;
    padding: 6px 0;
  }
  /deep/.el-tree-node__content {
    height: auto;
    min-height: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/baseInfoManage/rolesPower.vue